// eslint-disable-next-line import/order

import './ncss-subset.css';

// eslint-disable-next-line @typescript-eslint/no-require-imports
import { jsx as _jsx } from "react/jsx-runtime";
var HtmlToReactParser = require('html-to-react').Parser;
var Richtext = function Richtext(props) {
  var _props$root$richtext;
  var _props$root = props.root,
    docTitle = _props$root.docTitle,
    submitText = _props$root.submitText,
    checkBoxText = _props$root.checkBoxText,
    helperText = _props$root.helperText,
    errorText = _props$root.errorText,
    expiredText = _props$root.expiredText,
    acceptedText = _props$root.acceptedText,
    notYetAcceptedText = _props$root.notYetAcceptedText,
    isAuthor = props.isAuthor,
    isNotification = props.isNotification;
  var text = ((_props$root$richtext = props.root.richtext) === null || _props$root$richtext === void 0 ? void 0 : _props$root$richtext.text) || props.root.text;
  var htmlToReactParser = new HtmlToReactParser();
  var convertToNDEClasses = function convertToNDEClasses(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('ol').forEach(function (i) {
      i.className = 'md3-sm ncss-list-ol';
    });
    doc.querySelectorAll('ul').forEach(function (i) {
      i.className = 'md3-sm ncss-list-ul';
    });
    doc.querySelectorAll('li').forEach(function (i) {
      i.className = 'md3-sm ncss-li';
    });
    doc.querySelectorAll('h1').forEach(function (i) {
      i.style.fontFamily = 'Nike TG';
      i.className = 'ncss-base fs28-lg fs20-sm';
    });
    doc.querySelectorAll('h2').forEach(function (i) {
      i.style.fontFamily = 'Nike TG';
      i.className = 'ncss-base fs22-lg fs16-sm';
    });
    doc.querySelectorAll('h3').forEach(function (i) {
      i.className = 'ncss-base fs18-lg fs12-sm';
    });
    doc.querySelectorAll('h4').forEach(function (i) {
      i.className = 'ncss-base fs16-lg fs12-sm';
    });
    doc.querySelectorAll('h5').forEach(function (i) {
      i.className = 'ncss-base fs14-lg fs12-sm';
    });
    doc.querySelectorAll('h6').forEach(function (i) {
      i.className = 'ncss-base fs12-lg fs12-sm';
    });
    doc.querySelectorAll('p').forEach(function (i) {
      i.className = 'ncss-base fs14-lg fs14-sm';
    });
    doc.querySelectorAll('b').forEach(function (i) {
      i.className = 'u-bold';
    });
    doc.querySelectorAll('i').forEach(function (i) {
      i.className = 'u-italic';
    });
    doc.querySelectorAll('u').forEach(function (i) {
      i.className = 'u-underline';
    });
    doc.querySelectorAll('table').forEach(function (i) {
      i.className = 'border-black';
    });
    doc.querySelectorAll('td').forEach(function (i) {
      i.style.verticalAlign = 'middle';
      i.className = 'border-bottom-black';
    });
    return doc.body.innerHTML;
  };
  function renderRichTextDocument() {
    return htmlToReactParser.parse(convertToNDEClasses(text));
  }
  function renderRichTextAuthoredDocument() {
    var authoredText = "<div><br/><h3> Document Title : ".concat(docTitle, "</h3>") + "<h3> Submit Button Text : ".concat(submitText, "</h3>") + "<h3> Check Box Text : ".concat(checkBoxText, "</h3>") + "<h3> Helper Text : ".concat(helperText, "</h3>") + "<h3> Error Text : ".concat(errorText, "</h3>") + "<h3> Expired Text : ".concat(expiredText, "</h3>") + "<h3> Accepted Text : ".concat(acceptedText, "</h3>") + "<h3> Not Yet Accepted Text : ".concat(notYetAcceptedText, "</h3></div>");
    return (
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      htmlToReactParser.parse(convertToNDEClasses(text + authoredText))
    );
  }
  return /*#__PURE__*/_jsx("div", {
    className: "ua-ncss",
    children: !isAuthor || isNotification ? renderRichTextDocument() : renderRichTextAuthoredDocument()
  });
};
export default Richtext;